import { render, staticRenderFns } from "./TableRiskAppraisal584.vue?vue&type=template&id=0e0cdd00&scoped=true"
import script from "./TableRiskAppraisal584.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal584.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal584.vue?vue&type=style&index=0&id=0e0cdd00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0cdd00",
  null
  
)

export default component.exports